<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <!--<p>aa</p>-->
    <!--<router-view/>-->
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',

//    provide() { // 注册一个方法
//      return {
//        reload: this.reload
//      }
//    },
//
//    data() {
//      return {
//        isRouterAlive: true
//      }
//    },
//
//    methods: {
//      reload() {
//        this.isRouterAlive = false
//        this.$nextTick(function () {
//          this.isRouterAlive = true
//          console.log('reload')
//        })
//      }
//    }
  }
</script>

<style>
  /*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  /*}*/
</style>
<style lang="scss">
  @import '../node_modules/normalize.css/normalize.css';
  // normalize.css 样式格式化
  @import './styles/index.scss'; // 全局自定义样式
  .el-date-editor .el-range-separator{
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue